module.exports = __webpack_public_path__ + "images/File.f2e70c1c02100f9dec80d539ab46b1cd.svg";